import React, { Fragment } from 'react'
import Navbar2 from '../../components/Navbar2/Navbar2'
import Hero4 from '../../components/hero4/Hero4'
import ProblemSection from '../../components/csp/ProblemSection'
import About from '../../components/about/about'
import PlatformPreview from '../../components/csp/PlatformPreview'
import PartnerPreview from '../../components/csp/PartnerPreview'
import CtaSection from '../../components/CtaSection/CtaSection'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer'

const HomePage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <Hero4 />
      <ProblemSection />
      <About />
      <PlatformPreview />
      <PartnerPreview />
      <CtaSection ctaClass={'wpo-cta-section-s2 pb-0'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}
export default HomePage
